(function () {
    clientApp.controller('mailjetCtrl', function ($scope) {
        $scope.init = function (spamListId) {
            $scope.spamListId = spamListId;
            $scope.recipients = null;
            $scope.positions = [];
            $scope._emailsToSendElement = document.getElementById('emails-to-send');
            $scope.getRecipients();
        };

        $scope.getRecipients = function () {
            $scope.recipients = null;
            $scope._emailsToSendElement.classList.add('hidden');
            $scope.positions = [];
            $('#mailjet-positions').find('input:checked').each(function (key, value) {
                $scope.positions.push($(value).val());
            });

            $.post(Routing.generate('app_mailjet_default_filterpersonsbyposition'), {spamListId: $scope.spamListId, positions: $scope.positions},
                function (data) {
                    $scope.$apply(function(){
                        $scope.recipients = data;
                        $scope._emailsToSendElement.classList.remove('hidden');
                    });
                }
            ).fail(function () {
                $scope.$apply(function () {
                    $scope.recipients = null;
                    $scope._emailsToSendElement.classList.remove('hidden');
                })
            });
        };

        $scope.toggle = function (person) {
            if (person.excluded) {
                $scope.include(person);
            } else {
                $scope.exclude(person);
            }
        };

        $scope.include = function (person) {
            $.post(Routing.generate('app_mailjet_spamlist_include', {spamList: $scope.spamListId}), { email: person.mail },
                function () {
                    $scope.$apply(function () {
                        person.excluded = false;
                    });
                });
        };

        $scope.exclude = function (person) {
            $.post(Routing.generate('app_mailjet_spamlist_exclude', {spamList: $scope.spamListId}),{ email: person.mail},
                function () {
                    $scope.$apply(function () {
                        person.excluded = true;
                    });
                });
        };
    })


        .filter('included', function() {
            return function(data) {
                if (!data) return data;
                return data.filter(function (item) {
                    return !item.excluded;
                });
            };
        });

})();